<template>
    <div
        class="af-save-search"
    >
        <SaveSearchBtn
            :size="size"
            :is-saved="isSaved"
            @click="openModal()"
            class="afu-truncate"
        >
            <FontAwesomeIcon
                :icon="btnIcon"
                class="afu-text-neutral--light"
            />
            <div class="af-search-save-btn-text afu-ml-2">
                {{ hasJobs ? btnText : btnTextCreate }}
            </div>
        </SaveSearchBtn>

        <C1Modal
            v-if="isModalOpen"
            modal-content-class="afu-p-4 md:afu-p-8 md:afu-pt-6"
            size="lg"
            @close="closeModal"
        >
            <template v-slot:header>
                <div class="afu-flex afu-items-center afu-justify-between afu-mb-8">
                    <div class="afu-flex afu-items-center af-text--4xl afu-text-black">
                        <span class="afu-mr-3 afu-text-900">
                            <FontAwesomeIcon :icon="btnIcon" />
                        </span>
                        <span class="afu-font-bold">
                            {{ $t('job_alert.save') }}
                        </span>
                    </div>
                    <a
                        href="#"
                        class="afu-text-neutral-dark afu-text-2xl"
                        @click.stop.prevent="closeModal()"
                    >
                        <FontAwesomeIcon :icon="['fal', 'times']" />
                    </a>
                </div>
            </template>
            <template v-slot:body>
                <SaveSearchForm
                    :is-login="isLogin"
                    @close="closeModal"
                    @saveComplete="onSaveComplete"
                />
            </template>
        </C1Modal>
    </div>
</template>

<script>
    import { mapState, mapMutations } from 'vuex';

    import C1Modal from '@/components/C1Components/C1Modal';
    import SaveSearchBtn from './SaveSearchBtn';
    import SaveSearchForm from './SaveSearchForm';

    export default {
        name: 'SaveSearch',

        components: {
            C1Modal,
            SaveSearchBtn,
            SaveSearchForm,
        },

        props: {
            hasJobs: {
                type: Boolean,
                default: true,
            },
            size: {
                type: String,
                default: 'md',
                validator: value => ['sm', 'lg', 'md', 'xl'].includes(value),
            },
        },

        data() {
            return {
                isModalOpen: false,
                isSaved: false,
                isLogin: false,
            };
        },

        computed: {
            ...mapState({
                $_me: state => state.me.user,
                $_isSearchSaveModalOpen: state => state.me.isSearchSaveModalOpen,
            }),

            btnIcon() {
                return this.isSaved ? ['far', 'check-circle'] : ['far', 'bell'];
            },

            btnText() {
                return this.isSaved ? this.$t('job_alert.saved') : this.$t('job_alert.save');
            },
            btnTextCreate() {
                return this.isSaved ? this.$t('job_alert.saved') : this.$t('job_alert.create');
            },
        },

        created() {
            if (this.$_me.id) {
                this.isModalOpen = this.$_isSearchSaveModalOpen;
            }
        },

        methods: {
            ...mapMutations('me', {
                $_OPEN_SEARCH_SAVE_MODAL: 'OPEN_SEARCH_SAVE_MODAL',
                $_CLOSE_SEARCH_SAVE_MODAL: 'CLOSE_SEARCH_SAVE_MODAL',
            }),

            onSaveComplete() {
                this.closeModal();
                this.isSaved = true;
            },

            openModal() {
                this.isModalOpen = true;
                if (this.$_me.id) {
                    this.isLogin = true;
                }
            },

            closeModal() {
                this.$_CLOSE_SEARCH_SAVE_MODAL();
                this.isModalOpen = false;
            },
        },
    };
</script>
